import { alertAnatomy } from '@chakra-ui/anatomy';
// import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import {
  createMultiStyleConfigHelpers,
  cssVar,
  PartsStyleFunction,
} from '@chakra-ui/styled-system';

const $fg = cssVar('alert-fg');
// const $bg = cssVar('alert-bg');

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    border: '1px',
    borderColor: $fg.reference,
    alignItems: 'flex-start',
  },
});

const tmtAlert: PartsStyleFunction<typeof alertAnatomy> = (props) => {
  const { colorScheme: c } = props;
  const fgColor = `${c}.500`;

  return {
    container: {
      bg: `${c}.alpha`,
      border: '1px solid',
      borderColor: fgColor,
      color: 'headingFontColor',
      alignItems: 'flex-start',
      _dark: {
        color: 'darkHeadingFontColor',
      },
    },
    icon: { color: fgColor },
  };
};

export default defineMultiStyleConfig({
  baseStyle,
  variants: { tmtAlert },
  defaultProps: { variant: 'tmtAlert' },
});
